const product = {
    async addProduction(letterOverride = null) {
        const isEditable = this.locals.IS_EDITABLE;
        const letter = letterOverride
            ?? (isEditable
                ? document.getElementById("editableLetter")?.value
                : this.locals.group.LETTER
            );
        const select = this.locals.inputs.DELIVERY_PRICE;
        if (select) {
            const option = select.options[select.selectedIndex];
            const price = parseFloat(option.dataset.price || 0);
            if (price > 0) {
                const payload = {
                        items: [
                            {
                            id: select.value,
                            quantity: 1,
                                properties: {
                                    _letter: letter,
                                    _unique: this.locals.UNIQUE,
                                },
                        },
                        ],
                };
                await cart.add(payload);
            }
        }
        return { ok: true };
    },
    autoSelectIfSingle(select) {
        if (!select) {
            return;
        }
        const validOptions = Array.from(select.options).filter(
            opt => opt.value && opt.value !== ""
        );
        if (validOptions.length === 1) {
            const onlyOption = validOptions[0];
            if (select.value !== onlyOption.value) {
                select.value = onlyOption.value;
                select.dispatchEvent(new Event("change", { bubbles: true }));
            }
        }
    },
    buildFormData() {
        const formData = new FormData();
        const properties = {
            _added: Date.now(),
            _delivery_date: this.locals.delivery.DATE,
            _delivery_day: this.locals.delivery.DAY,
            _delivery_window_days_begin: Number(document.getElementById("deliveryWindowDaysBegin")?.value || 0),
            _delivery_window_days_end: Number(document.getElementById("deliveryWindowDaysEnd")?.value || 0),
            _letter: this.locals.group.LETTER,
            _personalization: "",
            _quantity: parseInt(this.locals.inputs.QUANTITY_PRICE.options[this.locals.inputs.QUANTITY_PRICE.selectedIndex].dataset.qty),
            _unique: this.locals.UNIQUE,
            "Product Color": this.locals.inputs.PRODUCT_COLOR.value,
            "Imprint Color": this.locals.inputs.IMPRINT_COLOR.value,
            "Est. Delivery": this.locals.delivery.FORMATTED,
            "Special Instructions": this.locals.inputs.SPECIAL_INSTRUCTIONS.value,
        };
        const designInputs = document.querySelectorAll('.product__design-guide-input');
        let personalization = "";
        const populateDesignGuide = {};
        designInputs.forEach(input => {
            const value = input.value.trim();
            if (!value) return;
            const label = input.dataset.label;
            properties[label] = value;
            personalization += `${label}: ${value}\n`;
            populateDesignGuide[label] = value;
        });
        if (personalization) {
            properties._personalization = personalization.trim();
        }
        if (Object.keys(populateDesignGuide).length) {
            properties._populate_design_guide = JSON.stringify(populateDesignGuide);
        }
        this.locals.files.UPLOADS.forEach((upload, i) => {
            formData.append(`properties[_file_name_${i}]`, upload.name);
            if (upload.file) {
                formData.append(`properties[_file_upload_${i}]`, upload.file);
            } else if (upload.url) {
                formData.append(`properties[_file_upload_${i}]`, upload.url);
            }
        });
        formData.append("properties[_upload_count]", this.locals.files.UPLOADS.length);
        Object.entries(properties).forEach(([key, value]) => {
            formData.append(`properties[${key}]`, value);
        });
        formData.append("id", this.locals.inputs.QUANTITY_PRICE.value);
        formData.append("quantity", 1);
        return formData;
    },
    deliveryOptions() {
        if (!this.locals.inputs.DELIVERY_PRICE) {
            return;
        }
        const days = this.getBusinessDays(10).reverse();
        const formatter = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
        });
        const formattedFmt = new Intl.DateTimeFormat("en-US", {
            weekday: "short",
            month: "numeric",
            day: "numeric",
            year: "2-digit",
        });
        const labelFmt = new Intl.DateTimeFormat("en-US", {
            weekday: "short",
            month: "short",
            day: "numeric",
        });
        const rawFmt = new Intl.DateTimeFormat("en-US", {
            month: "numeric",
            day: "numeric",
            year: "2-digit",
        });
        Array.from(this.locals.inputs.DELIVERY_PRICE.options).forEach((option, k) => {
            if (option.value === "") return;
            const date = days[k];
            if (!date) return;
            option.dataset.deliveryDate = rawFmt.format(date);
            option.dataset.formattedDate = formattedFmt.format(date);
            option.dataset.label = labelFmt.format(date);
            option.textContent = `${option.dataset.label} (${formatter.format(option.dataset.price)})`;
        });
        this.locals.inputs.DELIVERY_PRICE.disabled = false;
    },
    deliveryWindow() {
        const daysBegin = Number(document.getElementById("deliveryWindowDaysBegin").value);
        const daysEnd = Number(document.getElementById("deliveryWindowDaysEnd").value);
        const days = this.getBusinessDays(daysEnd);
        const startDate = days[daysBegin - 1];
        const endDate = days[daysEnd - 1];
        const fmtMachine = new Intl.DateTimeFormat("en-US", {
            month: "numeric",
            day: "numeric",
            year: "2-digit"
        });
        const startMonth = startDate.toLocaleString("en-US", { month: "numeric" });
        const endMonth = endDate.toLocaleString("en-US", { month: "numeric" });
        const startDay = startDate.getDate();
        const endDay = endDate.getDate();
        const formatted = `${startMonth}/${startDay} – ${endMonth}/${endDay}`;
        this.locals.delivery.FORMATTED = formatted;
        this.locals.delivery.DATE = fmtMachine.format(endDate);
        this.locals.delivery.DAY = daysEnd;
        product.locals.UPSELLER_DELIVERY_DATE.innerText = this.locals.delivery.FORMATTED;
    },
    async fetchProductsRelated() {
        try {
            const design = this.locals.product.DESIGN;
            let vendorSku = this.locals.product.SKU_VENDOR;
            if (vendorSku?.toUpperCase().startsWith("PA")) {
                vendorSku = vendorSku.slice(2);
            }
            const query = encodeURIComponent(`tag:${design || "design"} -tag:${vendorSku}`);
            const related = await fetch(`/search?q=${query}&section_id=search__related`);
            const html = await related.text();
            const temp = document.createElement("div");
            temp.innerHTML = html;
            const section = temp.querySelector("#shopify-section-search__related");
            const mount = document.querySelector("#relatedProducts");
            mount.innerHTML = "";
            if (section) {
                mount.appendChild(section);
            } else {
                mount.innerHTML = temp.innerHTML;
            }
        } catch (e) {
            console.error(e);
        }
    },
    formatOptions(select, formatter) {
        Array.from(select.options).forEach(option => {
            const isSelected = option === select.options[select.selectedIndex];
            const price = formatter.format(parseFloat(option.dataset.price));
            let label = option.dataset.label;
            if (!label) {
                if (select.id === "quantityPrice") {
                    label = `${option.dataset.qty} pcs`;
                } else if (select.id === "deliveryPrice") {
                    label = option.dataset.formattedDate || "";
                }
            }
            option.textContent = isSelected
                ? label
                : `${label} (${price})`;
        });
    },
    getBusinessDays(count) {
        const start = new Date();
        const holidays = JSON.parse(document.getElementById("holidays").value);
        const days = [];
        let cursor = new Date(start);
        while (days.length < count) {
            cursor.setDate(cursor.getDate() + 1);
            const formattedDate = cursor.toLocaleDateString("en-US", {
                month: "2-digit",
                day: "2-digit",
                year: "numeric"
            });
            const day = cursor.getDay();
            if (
                day !== 0 &&
                day !== 6 &&
                !holidays.includes(formattedDate)
            ) {
                days.push(new Date(cursor));
            }
        }
        return days;
    },
    handleAccordion() {
        const isDesktop = window.matchMedia("(min-width: 992px)").matches;
        document.querySelectorAll(".accordion-item").forEach((item, index) => {
            const collapse = item.querySelector(".accordion-collapse");
            const button  = item.querySelector(".accordion-button");
            if (!collapse || !button) return;
            if (isDesktop
                && 0 === index
            ) {
                collapse.classList.add("show");
                button.classList.remove("collapsed");
                button.setAttribute("aria-expanded", "true");
            } else {
                collapse.classList.remove("show");
                button.classList.add("collapsed");
                button.setAttribute("aria-expanded", "false");
            }
        });
    },
    handleFiles(files) {
        const max = this.locals.files.SIZE_MAX;
        for (const file of files) {
            if (file.size > max) {
                alert(`"${file.name}" is too large. The max allowed is ${Math.round(max / 1024 / 1024)}MB.`);
                continue;
            }
            if (this.locals.files.UPLOADS.length >= 2) break;
            const index = this.locals.files.UPLOADS.length + 1;
            this.locals.files.UPLOADS.push({
                name: `Upload #${index}`,
                file: file,
                url: null
            });
        }
        this.reindexUploads();
        this.renderUploads();
    },
    async init() {
        const currentCart = await cart.fetchCart();
        const params = new URLSearchParams(location.search);
        const editable = params.get("e") ;
        let editableDelivery = null;
        let editableItem = null;
        let toCartText = "Add To Cart";
        if (editable) {
            toCartText = "Update Cart";
            editableDelivery = currentCart.items.find(
                i =>
                    i.product_type === "Production" &&
                    i.product_title === "Rush Delivery" &&
                    i.properties?._unique === editable
            );
            editableItem = currentCart.items.find(
                i =>
                    i.properties?._unique === editable &&
                    i.sku !== null
            );
            this.locals.IS_EDITABLE = true;
        } else {
            const inUse = currentCart.items.map(i => i.properties._letter);
            const pickFrom = this.locals.group.LETTERS.filter(
                f => !inUse.includes(f)
            );
            this.locals.group.LETTER = pickFrom[0];
        }
        this.locals.CART_BUTTON_TEXT.innerText = toCartText;
        this.locals.delivery.MODE = document.getElementById("deliveryMode").value;
        switch (this.locals.delivery.MODE) {
            case "options":
                this.deliveryOptions();
                break;
            case "window":
                this.deliveryWindow();
                break;
        }
        this.resetDropZone();
        this.setHandlers();
        // const initialVariant = this.resolveInitialVariant(editableItem);
        // if (initialVariant
        //     && this.locals.inputs.QUANTITY_PRICE
        // ) {
        //     const select = this.locals.inputs.QUANTITY_PRICE;
        //     const option = Array.from(select.options).find(
        //         opt => opt.value == initialVariant
        //     );
        //     if (option) {
        //         select.value = option.value;
        //         select.dispatchEvent(new Event("change", { bubbles: true }));
        //     }
        // }
        if (editableDelivery
            && this.locals.inputs.DELIVERY_PRICE
        ) {
            this.locals.inputs.DELIVERY_PRICE.value = editableDelivery.variant_id;
            this.locals.remove_keys.DELIVERY = editableDelivery.key;
        }
        if (editableItem) {
            if (this.locals.inputs.IMPRINT_COLOR) {
                const imprintValue = editableItem?.properties["Imprint Color"];
                if (imprintValue) {
                    this.locals.inputs.IMPRINT_COLOR.value = imprintValue;
                    this.locals.inputs.IMPRINT_COLOR.dispatchEvent(new Event("change"));
                }
            }
            if (this.locals.inputs.PRODUCT_COLOR) {
                const productValue = editableItem?.properties["Product Color"];
                if (productValue) {
                    this.locals.inputs.PRODUCT_COLOR.value = productValue;
                    this.locals.inputs.PRODUCT_COLOR.dispatchEvent(new Event("change"));
                }
            }
            this.locals.inputs.QUANTITY_PRICE.value = editableItem.variant_id;
            this.locals.inputs.SPECIAL_INSTRUCTIONS.value = editableItem.properties["Special Instructions"] || "";
            if (Number(editableItem.properties._upload_count || 0) > 0) {
                this.locals.files.UPLOADS = [];
                for (let i = 0; i < 2; i++) {
                    const name = editableItem.properties[`_file_name_${i}`];
                    const url = editableItem.properties[`_file_upload_${i}`];
                    if (!name && !url) {
                        continue;
                    }
                    this.locals.files.UPLOADS.push({
                        name: name,
                        url: url,
                        file: null
                    });
                }
                this.renderUploads();
            }
            if (editableItem.properties?._populate_design_guide) {
                const guide = JSON.parse(editableItem.properties._populate_design_guide);
                document.querySelectorAll('.product__design-guide-input').forEach(input => {
                    const label = input.dataset.label;
                    if (undefined !== guide[label]) {
                        input.value = guide[label];
                    }
                });
            }
            this.locals.remove_keys.PRODUCT = editableItem.key;
        }
        this.autoSelectIfSingle(this.locals.inputs.PRODUCT_COLOR);
        this.autoSelectIfSingle(this.locals.inputs.IMPRINT_COLOR);
        this.handleAccordion();
        if (this.locals.inputs.DELIVERY_PRICE) {
            this.updatePrice(this.locals.inputs.DELIVERY_PRICE);
            this.locals.inputs.DELIVERY_PRICE.dispatchEvent(new Event("change"));
        }
        this.updatePrice(this.locals.inputs.QUANTITY_PRICE);
        this.locals.inputs.SPECIAL_INSTRUCTIONS.dispatchEvent(new Event("input"));
        this.locals.inputs.CART_BUTTON.disabled = "true" === product.locals.inputs.PRODUCT_OUT_OF_STOCK.value;
        this.fetchProductsRelated();
    },
    json(result) {
        if (!result
            || "[]" === result
        ) {
            return false;
        }
        let json = false;
        try {
            json = JSON.parse(result);
        } catch (e) {
            return false;
        }
        return json;
    },
    locals: {
        CART_BUTTON_TEXT: document.getElementById("pdt-addToCartText"),
        CART_EMPTY: false,
        CART_DIVISOR: parseInt(document.getElementById("cartDivisor").value),
        CDN_FILES: window.cdnFiles,
        COLORS: "",
        delivery: {
            DATE: "",
            DAY: "",
            FORMATTED: "",
            MODE: "",
            OPTIONS: false,
            WINDOW: false,
        },
        drop_zone: {
            CONTENT: document.getElementById("dropZoneContent"),
            MAIN: document.getElementById("dropZone"),
            OVERLAY: document.getElementById("dropZoneOverlay"),
            TEMPLATE: document.getElementById("dropZoneTemplate"),
        },
        IS_EDITABLE: false,
        files: {
            SIZE_THRESHOLD: 300 * 1024,
            SIZE_MAX: 5 * 1024 * 1024, /* 5MB... */
            UPLOADS: [],
        },
        group: {
            LETTER: "A",
            LETTERS: ["A", "B", "C", "D", "E", "F", "G", "H"],
        },
        IMPRINT_COLOR: "",
        inputs: {
            CART_BUTTON: document.getElementById("addToCartButton"),
            DELIVERY_PRICE: document.getElementById("deliveryPrice"),
            FILE_UPLOAD: document.getElementById("fileUpload"),
            IMPRINT_COLOR: document.getElementById("imprintColor"),
            PRODUCT_COLOR: document.getElementById("productColor"),
            PRODUCT_OUT_OF_STOCK: document.getElementById("productOutOfStock"),
            QUANTITY_PRICE: document.getElementById("quantityPrice"),
            SPECIAL_INSTRUCTIONS: document.getElementById("specialInstructions"),
        },
        PRODUCT_COLOR: "",
        product: {
            COLOR: "",
            DESIGN: document.getElementById("productDesign").value,
            ID: parseInt(document.getElementById("productId").value),
            SKU: parseInt(document.getElementById("productSku").value),
            SKU_VENDOR: document.getElementById("productVendorSku").value,
            VARIANT_ID: parseInt(document.getElementById("productVariantId").value),
        },
        production: {
            CUTOFF: parseInt(document.getElementById("productionCutoff").value),
            DAYS: parseInt(document.getElementById("productionStart").value),
        },
        remove_keys: {
            DELIVERY: null,
            PRODUCT: null,
        },
        UNIQUE: crypto.randomUUID(),
        UPSELLER_DELIVERY_DATE: document.getElementById("pdt-upsellerDeliveryDate"),
    },
    newUnique() {
        this.locals.UNIQUE = crypto.randomUUID();
    },
    reindexUploads() {
        this.locals.files.UPLOADS.forEach((upload, i) => {
            upload.name = `Upload #${i + 1}`;
        });
    },
    removeUpload(index) {
        this.locals.files.UPLOADS.splice(index, 1);
        this.reindexUploads();
        this.renderUploads();
    },
    renderUploads() {
        const container = this.locals.drop_zone.CONTENT;
        if (!container) {
            return;
        }
        const files = this.locals.files.UPLOADS;
        container.classList.toggle("empty", files.length === 0);
        container.classList.toggle("has-files", files.length > 0);
        if (files.length === 0) {
            this.resetDropZone();
            return;
        }
        container.classList.add("has-files");
        const slots = [];
        for (let i = 0; i < 2; i++) {
            const file = files[i];
            if (file) {
                 slots.push(`
                    <div class="product__upload-item">
                        <button class="btn btn-secondary product__upload-item-button" data-index="${i}" type="button">
                            <span>${file.name}</span>
                            <span class="remove-upload"">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                    fill="currentColor" class="bi bi-x-square-fill" viewBox="0 0 16 16">
                                    <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm3.354 4.646L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 1 1 .708-.708"/>
                                </svg>
                            </span>
                        </button>
                    </div>
                `);
            }
        }
        container.innerHTML = slots.join("");
    },
    reset() {
        document.getElementById("productForm").reset();
        dropdown.reset();
        const url = new URL(window.location.href);
        url.searchParams.delete("e");
        history.replaceState(null, "", url);
        this.locals.CART_BUTTON_TEXT.innerText = "Add To Cart";
        this.locals.inputs.QUANTITY_PRICE.dispatchEvent(new Event("change"));
        this.locals.inputs.SPECIAL_INSTRUCTIONS.rows = 2;
        this.locals.IS_EDITABLE = false;
        this.resetDropZone();
    },
    resetDropZone() {
        const container = this.locals.drop_zone.CONTENT;
        if (!container) {
            return;
        }
        container.classList.remove("has-files");
        container.innerHTML = "";
        container.appendChild(
            this.locals.drop_zone.TEMPLATE.content.cloneNode(true)
        );
    },
    // resolveInitialVariant(editableItem) {
    //     const params = new URLSearchParams(location.search);
    //     if (params.get("e")
    //         && editableItem
    //     ) {
    //         return editableItem.variant_id;
    //     }
    //     if (params.get("variant")) {
    //         return params.get("variant");
    //     }
    //     return null;
    // },
    runUploadUX() {
        const uploads = this.locals.files.UPLOADS;
        const totalSize = uploads.reduce(
            (sum, f) => sum + (f.file?.size || 0),
            0
        );
        const shouldShow = uploads.length > 0
            && totalSize > this.locals.files.SIZE_THRESHOLD;
        if (!shouldShow) {
            return {
                enabled: false,
                stop: async () => {}
            };
        }
        const progressBar = document.getElementById("uploadProgressBar");
        this.setUploadOverlay("show", "Starting upload...", 0);
        progressBar.style.width = "0%";
        let progress = 0;
        const interval = setInterval(() => {
            if (progress < 70) {
                progress += Math.random() * 8;

                this.setUploadOverlay(
                    "show",
                    "Uploading files...",
                    Math.min(progress, 70)
                );
            }
        }, 120);
        return {
            enabled: true,
            stop: async () => {
                clearInterval(interval);
                this.setUploadOverlay("show", "Finalizing...", 85);
                await new Promise(r => setTimeout(r, 200));
                this.setUploadOverlay("show", "Done", 100);
                await new Promise(r => setTimeout(r, 200));
                this.setUploadOverlay("hide");
            }
        };
    },
    setHandlers() {
        /*const SLIDE_MAP = {
            imprintColor: "imprint-addon-image",
            productColor: "colors-addon-image",
        };
        document.addEventListener("dropdown:clicked", e => {
            const target = e.detail.target;
            const key = SLIDE_MAP[target];
            if (key) {
                product.showSlideByKey(key);
            }
        });*/
        document.querySelectorAll(".form-validate").forEach(el => {
            el.addEventListener("change", function () {
                this.blur();
                const target = document.getElementById(this.dataset.target);
                if (!target) {
                    return;
                }
                target.dataset.state = this.checkValidity() ? "valid" : "invalid";
            });
        });
        document.querySelectorAll(".product__show-design-guide").forEach(el => {
            const handler = () => product.showSlideByKey("design-guide");
            el.addEventListener("pointerdown", handler);
            el.addEventListener("focus", handler);
        });
        document.querySelectorAll(".update-price").forEach(
            e => {
                e.addEventListener("change", function() {
                    product.updatePrice(this);
                }
            )
        });
        const productForm = document.getElementById("productForm");
        this.locals.inputs.CART_BUTTON.addEventListener("click", async () => {
            if (!productForm.checkValidity()) {
                productForm.reportValidity();
                return false;
            }
            await product.syncCart();
        });
        document.addEventListener("cart:changed:item-removed", () => {
            product.reset();
        });
        if (this.locals.inputs.DELIVERY_PRICE) {
            this.locals.inputs.DELIVERY_PRICE.addEventListener("change", function() {
                const selected = this.selectedOptions[0];
                product.locals.UPSELLER_DELIVERY_DATE.innerText = selected.dataset.formattedDate || "";
                const upsellerDeliveryType = document.getElementById("pdt-upsellerDeliveryType");
                if (upsellerDeliveryType) {
                    document.getElementById("pdt-upsellerDeliveryType").innerText = 0 === Number(selected.dataset.price) ? "FREE" : "RUSH";
                }
            });
        }
        if (this.locals.drop_zone.MAIN) {
            this.locals.drop_zone.MAIN.addEventListener("click", (e) => {
                const btn = e.target.closest(".remove-upload");
                if (!btn || !this.locals.drop_zone.MAIN.contains(btn)) return;
                this.removeUpload(parseInt(btn.dataset.index));
            });
            this.locals.drop_zone.MAIN.addEventListener("dragover", e => {
                e.preventDefault();
                product.locals.drop_zone.MAIN.classList.add("dragover");
            });
            this.locals.drop_zone.MAIN.addEventListener("dragleave", () => {
                product.locals.drop_zone.MAIN.classList.remove("dragover");
            });
            this.locals.drop_zone.MAIN.addEventListener("drop", e => {
                e.preventDefault();
                dropZone.classList.remove("dragover");
                const files = e.dataTransfer.files;
                if (files.length) {
                    product.locals.inputs.FILE_UPLOAD.files = files;
                    product.locals.inputs.FILE_UPLOAD.dispatchEvent(new Event("change", { bubbles: true }));
                }
            });
        }
        if (this.locals.inputs.FILE_UPLOAD) {
            this.locals.inputs.FILE_UPLOAD.addEventListener("change", function() {
                product.handleFiles(this.files);
                this.value = "";
            });
        }
        // $("#slider").on("mouseenter mousemove mouseleave", "[data-zoom]", function (e) {
        //     if (global.isTouch) return;
        //     const zoomSrc = this.dataset.zoom;
        //     if (!zoomSrc) return;
        //     switch (e.type) {
        //         case "mouseenter":
        //             if (!this._zoom) product.zoomStart(this, zoomSrc);
        //             break;
        //         case "mousemove":
        //             product.zoomMove(e, this);
        //             break;
        //         case "mouseleave":
        //             product.zoomStop(this);
        //             break;
        //     }
        // });
        this.locals.inputs.SPECIAL_INSTRUCTIONS.addEventListener("input", function () {
            this.rows = Math.max(2, this.value.split("\n").length);
        });
    },
    setUploadOverlay(state, text = "", percent = 0) {
        const overlay = this.locals.drop_zone.OVERLAY;
        if (!overlay) {
            return;
        }
        const textEl = document.getElementById("uploadStatusText");
        const bar = document.getElementById("uploadProgressBar");
        if (!overlay) return;
        if (state === "show") {
            overlay.classList.remove("d-none");
        } else {
            overlay.classList.add("d-none");
            bar.style.width = "0%";
            return;
        }
        if (text) textEl.textContent = text;
        bar.style.width = percent + "%";
    },
    showSlideByKey(img) {
        const target = document.querySelector(`#thumbnails [data-img="${img}"]`);
        if (!target || target.classList.contains("active")) {
            return;
        }
        target.click();
    },
    async syncCart() {
        const cartBtn = product.locals.inputs.CART_BUTTON;
        const spinner = document.querySelector(".js-spinner");
        try {
            spinner.style.display = "inline-block";
            cartBtn.disabled = true;
            let updates = {};
            if (this.locals.IS_EDITABLE) {
                updates = Object.fromEntries(
                    Object.values(this.locals.remove_keys)
                        .filter(Boolean)
                        .map(r => [r, 0])
                );
            }
            if (Object.keys(updates).length > 0) {
                await cart.update(updates);
            }
            const uploadUX = this.runUploadUX();
            this.locals.UNIQUE = crypto.randomUUID();
            const prodAdded = await this.addProduction();
            if (!prodAdded?.ok) {
                throw new Error("Failed to add production item");
            }
            const formData = this.buildFormData();
            const itemAdded = await cart.safeAdd(formData);
            const cartData = await cart.fetchCart();
            cart.updateItemsCount(cartData.item_count);
            await uploadUX.stop();
            if ("true" === cartBtn.dataset.drawer) {
                this.reset();
                document.dispatchEvent(new CustomEvent("cart:drawer"));
                return;
            }
            window.location.href = "/cart";
        } catch (e) {
            alert(e.message || "Something went wrong while adding to cart.");
        } finally {
            cartBtn.disabled = false;
            spinner.style.display = "none";
            this.setUploadOverlay("hide");
        }
    },
    updatePrice(select) {
        const formatter = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
        });
        const inputDeliveryPrice = this.locals.inputs.DELIVERY_PRICE;
        const inputDeliveryPriceOpt = inputDeliveryPrice?.selectedOptions[0];
        const inputQuantityPrice = this.locals.inputs.QUANTITY_PRICE;
        const inputQuantityPriceOpt = inputQuantityPrice.selectedOptions[0];
        const deliveryPrice = inputDeliveryPriceOpt ? parseFloat(inputDeliveryPriceOpt.dataset.price) : 0;
        const quantityPrice = parseFloat(inputQuantityPriceOpt.dataset.price);
        if (inputDeliveryPriceOpt) {
            this.locals.delivery.DATE = inputDeliveryPriceOpt.dataset.deliveryDate;
            this.locals.delivery.DAY = Number(inputDeliveryPriceOpt.dataset.day);
            this.locals.delivery.FORMATTED = inputDeliveryPriceOpt.dataset.formattedDate;
        }
        $(".product__total").text(
            formatter.format(quantityPrice + deliveryPrice)
        );
        document.getElementById("pdt-noticeForQty").textContent = inputQuantityPriceOpt.dataset.label;
        this.formatOptions(inputQuantityPrice, formatter);
        if (inputDeliveryPrice) {
            this.formatOptions(inputDeliveryPrice, formatter);
        }
    },
};
$(() => {
    product.init();
});
window.matchMedia("(min-width: 992px)").addEventListener("change", product.handleAccordion);